const isRocket = process.env.CPA_ENV === 'rocket';

const levelsEverad = {
	noob: 'noob',
	average: 'average',
	registered: 'registered',
	deactivated: 'deactivated'
};

const levelsRocket = {
	noob: 'noob',
	average: 'average',
	not_valid: 'not_valid',
	banned: 'banned',
	deactivated: 'deactivated'
};

const localeEverad = {
	ru: {
		noob: 'новичок',
		average: 'обычный',
		registered: 'зарегистрирован',
		deactivated: 'деактивирован'
	},
	en: levelsEverad,
	uk: levelsEverad,
	de: {
		noob: 'Anfänger',
		average: 'mittlere',
		registered: 'eingetragen',
		deactivated: 'deactivated'
	},
	vi: levelsEverad,
	th: {
		noob: 'คนที่ใช้ระบบออนไลน์ ผู้เล่นใหม่',
		average: 'ปกติ',
		registered: 'จดทะเบียน',
		deactivated: 'deactivated'
	}
};

const localeRocket = {
	ru: {
		noob: 'Не активный',
		average: 'Активный',
		not_valid: 'Недействительный',
		banned: 'Забанен',
		deactivated: 'Деактивирован'
	},
	en: {
		noob: 'Not active',
		average: 'Active',
		not_valid: 'Not valid',
		banned: 'Banned',
		deactivated: 'Deactivated'
	},
	de: {
		noob: 'Not active',
		average: 'Active',
		not_valid: 'Not valid',
		banned: 'Banned',
		deactivated: 'Deactivated'
	},
	vi: {
		noob: 'Not active',
		average: 'Active',
		not_valid: 'Not valid',
		banned: 'Banned',
		deactivated: 'Deactivated'
	},
	th: {
		noob: 'Not active',
		average: 'Active',
		not_valid: 'Not valid',
		banned: 'Banned',
		deactivated: 'Deactivated'
	}
};

module.exports = {
	enum: isRocket ? levelsRocket : levelsEverad,
	locale: isRocket ? localeRocket : localeEverad
};



// WEBPACK FOOTER //
// ./enums/affiliate-levels.js